module.exports = __webpack_public_path__ + "img/is-it-known.4a4edd7e.jpeg";